import React from "react";
import Header from "../../components/Header/Header";
import AllProducts from "../../sections/AllProducts/AllProducts";
import "./DiscoverByGenre.css";

function DiscoverByGenre() {
  return (
    <main className="DiscoverByGenre">
      <Header
        title="Discover Our Collection"
        subtitle="Explore Thousands of Books Across All Genres"
        actionBtn="Start Browsing"
      />
      <AllProducts />
    </main>
  );
}

export default DiscoverByGenre;
